/**
 * Analytics event helpers for Simple Analytics.
 * Use for key feature usage; page views are auto-collected for SPA navigation.
 */

declare global {
  interface Window {
    sa_event?: (
      eventName: string,
      params?: Record<string, string | number | boolean | undefined>,
    ) => void;
  }
}

export function trackEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | undefined>,
): void {
  if (typeof window === "undefined" || !window.sa_event) return;
  try {
    window.sa_event(eventName, params);
  } catch {
    // ignore
  }
}

export function trackPageView(pagePath: string, pageTitle?: string): void {
  void pagePath;
  void pageTitle;
  // Simple Analytics auto-collects page views for SPA route changes.
}
